import axios from 'axios';

const BASE_URL = '/ztna_applications';

export function getZtnaApplications(params) {
  return axios.get(`${BASE_URL}`, { params });
}

export function deleteZtnaApplication(id) {
  return axios.delete(`${BASE_URL}/${id}`);
}

export function createZtnaApplication(params) {
  return axios.post(`${BASE_URL}`, { ztna_application: params });
}

export function updateZtnaApplication(id, params) {
  return axios.patch(`${BASE_URL}/${id}`, {
    ztna_application: params,
  });
}
